import { apiRequest, buildApiUrl, API_CONFIG } from '../utils/api';

// Servicio para manejar tareas
export class TaskService {
  // Obtener tareas de un proyecto específico
  static async getProjectTasks(projectId) {
    try {
      const response = await apiRequest(buildApiUrl(`${API_CONFIG.ENDPOINTS.PROJECT}/${projectId}`), {
        method: 'GET'
      });
      
      if (response.response && response.response.content && response.response.content.tasks) {
        return {
          success: true,
          tasks: response.response.content.tasks,
          operationId: response.operationId
        };
      } else {
        throw new Error('No tasks found in response');
      }
    } catch (error) {
      console.error('Error fetching project tasks:', error);
      return {
        success: false,
        error: error.message,
        tasks: []
      };
    }
  }

  // Crear una nueva tarea
  static async createTask(taskData) {
    try {
      const response = await apiRequest(buildApiUrl(API_CONFIG.ENDPOINTS.TASKS), {
        method: 'POST',
        body: JSON.stringify(taskData)
      });
      
      return {
        success: true,
        task: response.response?.content?.task || response,
        operationId: response.operationId
      };
    } catch (error) {
      console.error('Error creating task:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Actualizar una tarea
  static async updateTask(taskId, taskData) {
    try {
      const response = await apiRequest(buildApiUrl(`${API_CONFIG.ENDPOINTS.TASK}/${taskId}`), {
        method: 'PUT',
        body: JSON.stringify(taskData)
      });
      
      return {
        success: true,
        task: response.response?.content?.task,
        operationId: response.operationId
      };
    } catch (error) {
      console.error('Error updating task:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Eliminar una tarea
  static async deleteTask(taskId) {
    try {
      const response = await apiRequest(buildApiUrl(`${API_CONFIG.ENDPOINTS.TASK}/${taskId}`), {
        method: 'DELETE'
      });
      
      return {
        success: true,
        operationId: response.operationId
      };
    } catch (error) {
      console.error('Error deleting task:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
}

// Función helper para formatear tareas de la API
export const formatTaskFromApi = (apiTask) => {
  return {
    id: apiTask.id.toString(),
    name: apiTask.name,
    description: apiTask.description,
    status: apiTask.status,
    initialDate: apiTask.initial_date,
    finalDate: apiTask.final_date,
    corporationId: apiTask.corporation_id,
    projectId: apiTask.project_id,
    // Campos adicionales para compatibilidad con el frontend
    color: getTaskColor(apiTask.status),
    priority: getTaskPriority(apiTask.status),
    assignee: null, // Se puede poblar desde otra API
    storyPoints: null, // Se puede poblar desde otra API
    epic: null, // Se puede poblar desde otra API
    sprint: null // Se puede poblar desde otra API
  };
};

// Función helper para obtener color según el estado
const getTaskColor = (status) => {
  const colorMap = {
    'pending': 'yellow',
    'in progress': 'green',
    'completed': 'blue',
    'cancelled': 'red',
    'blocked': 'red'
  };
  return colorMap[status] || 'gray';
};

// Función helper para obtener prioridad según el estado
const getTaskPriority = (status) => {
  const priorityMap = {
    'pending': 'medium',
    'in progress': 'high',
    'completed': 'low',
    'cancelled': 'low',
    'blocked': 'high'
  };
  return priorityMap[status] || 'medium';
};

